import React from "react";
import "./AboutMyselfPage.css";

const AboutMyselfTxt = () => {
  return (
    <div className="aboutMyselfTxtContainer">
      <h2>Going organic the SCENT way</h2>
      <li>
        All About Myself is elegance compressed into a beauty bar. Use it for
        yourself or gift to a friend: spread the Scent lifestyle! Go organic the
        Scent way.
      </li>
      <li>
        All About Myself is a range of hand-crafted, exclusive and eco-friendly
        bath and beauty products. At Scent, we believe that it is important to
        maintain our connection with mother nature. All About Myself is about
        sustaining that connection.
      </li>
      <li>
        What goes into it: There are no artificial additives, preservatives,
        parabens, or hardening agents. All ingredients are organic. The mainstay
        of All About Myself soaps is coconut oil. Almond oil, and olive oil form
        the other main components. The pleasing aroma of our products are from
        natural elements like fruit extracts and spices. We also use tropical
        butter like Shea butter to enhance the natural moisturizing and skin
        smoothening properties of the other ingredients. The Scent vision is to
        do away with synthetic products that harm the skin.
      </li>
      <li>
        How it is made: We do not have large factories. The All About Myself
        range of products are made by local artisans. The soaps are made in
        three batches all through the year. We use the cold process method.
        Hence, our ingredients retain their natural goodness and properties. The
        whole process is carefully supervised and done with oodles of love. It
        is also very important to us that the production process is sustainable
        and eco-friendly. To reduce our carbon footprint, we source seasonal and
        regional ingredients.
      </li>
      <li>
        Why use All About Myself: ‘Coz we understand allure, we understand skin.
        Our products are mild, classy & organic. We have a range of products
        suitable for different skin-types. Using All About Myself is not just
        about pampering yourself, it is about taking care of yourself for the
        long-term. And Scent products are fun; taking care of yourself will no
        longer be a chore!
      </li>
      <li>
        Want to re-create the Scent experience at home? Pamper your skin
        salon-style with All About Myself bath and beauty products. Feel the
        spa-experience every single day and watch your body glow.
      </li>
    </div>
  );
};

export default AboutMyselfTxt;
